import { combineReducers } from "@reduxjs/toolkit";

import AffProfile from "./affProfile/affProfileSlice";
import authLogo from "./authLogo/authLogoSlice";
import authUser from "./authUser/authUserSlice";
import badRequests from "./badRequests/badRequestsSlice";
import colorSettings from "./colorSettings/colorSettingsSlice";
import forgetPassword from "./forgetPwd/forgetPwdSlice";
import LockScreen from "./lockScreen/lockScreenSlice";
import permissions from "./permissions/permissionsSlice";
import Layout from "./permissions/permissionsSlice";
import Profile from "./profile/profileSlice";

const rootReducer = combineReducers({
  AffProfile,
  Layout, // does not use will be deleted
  Profile,
  forgetPassword,
  badRequests,
  authUser,
  LockScreen,
  permissions,
  colorSettings,
  authLogo,
});

export default (state: any, action: any) => rootReducer(state, action);
